<template>
  <form
    autocomplete="off"
    method="post"
    action=""
    class="text-center mx-auto w-full flex flex-col items-center"
  >
    <!-- <form> and <input name="hidden"/> is needed to avoid chrome default autofill -->
    <input
      autocomplete="false"
      name="hidden"
      type="text"
      style="display: none"
    />
    <vpf-input
      autocomplete="false"
      v-for="input in $store.state.data.Steps[$store.state.activeStep].Form"
      :key="input.Id"
      type="address"
      @inputWasChanged="setValidity($event)"
      id="autocomplete"
      :name="input.Name"
      :placeholder="input.Placeholder"
      :is-required="input.Required"
      :label="input.Label"
      :is-value-from-list="isSelectedFromList"
      :error-message="input.ErrorMessage"
      :value="$store.state.addressText"
      :wide="true"
      @input="resetValidation()"
      ref="autocompleteInput"
    />
    <vpf-button
      :is-disabled="!isSelectedFromList && form.isInvalid"
      class="md:mt-6"
      @click.native="setNextStep()"
    >
      {{ $store.state.data.Steps[$store.state.activeStep].ButtonTextNext }}
    </vpf-button>
  </form>
</template>

<script>
import Button from "../shared/Button";
import Input from "../shared/Input";

import { mapMutations } from "vuex";

export default {
  data() {
    return {
      form: {
        isInvalid: true
      },
      isInitialized: false
    };
  },
  components: {
    "vpf-button": Button,
    "vpf-input": Input
  },
  mounted() {
    this.initAutoComplete();
    this.$refs.autocompleteInput[0].$refs.focusInput.focus();
  },
  computed: {
    isSelectedFromList() {
      return this.$store.state.addressText !== "";
    }
  },
  methods: {
    ...mapMutations([
      "removeAddressUserInputs",
      "updateUserInput",
      "updateAddressText",
      "nextStep"
    ]),
    setValidity(e) {
      this.form.isInvalid = e;
    },
    setNextStep() {
      this.nextStep();
    },
    updateAddressData(place) {
      let address = {};

      place.address_components.forEach(addressComponents => {
        addressComponents.types.forEach(type => {
          let key =
            type == "street_number"
              ? "StreetNumber__c"
              : type == "route"
              ? "Street__c"
              : type == "postal_code"
              ? "PostalCode__c"
              : type == "locality"
              ? "City__c"
              : type == "postal_town"
              ? "City__c"
              : type == "sublocality"
              ? "Region__c"
              : type == "country"
              ? "Country__c"
              : undefined;

          if (key) address[key] = addressComponents["short_name"];
        });
      });

      this.removeAddressUserInputs();
      this.updateUserInput(address);

      let addressTextValue =
        this.$refs.autocompleteInput[0].$refs.focusInput.value;
      this.updateAddressText(addressTextValue);

      // With updating the validation state we loose the selected address text so we put it back to the input field
      this.$nextTick(() => {
        this.$refs.autocompleteInput[0].$refs.focusInput.value =
          this.$store.state.addressText;
      });
    },
    resetValidation() {
      this.updateAddressText("");
    },
    initAutoComplete() {
      let allowedCountries = this.$store.state.data.AllowedCountries;
      allowedCountries = allowedCountries.filter(item => item.trim() != ""); // remove empty items
      allowedCountries.forEach((item, i) => {
        allowedCountries[i] = item.trim().toLowerCase(); // in case of white space or capital letter we fix that
      });

      const hasRestrictedCountry = allowedCountries.length > 0;

      if (hasRestrictedCountry && allowedCountries.length === 1)
        allowedCountries = allowedCountries[0];

      if (window.google && !this.isInitialized) {
        let options = undefined;
        if (hasRestrictedCountry) {
          options = {
            componentRestrictions: { country: allowedCountries }
          };
        }

        const input = document.getElementById("autocomplete");
        const autocomplete = new window.google.maps.places.Autocomplete(
          input,
          options
        );

        window.google.maps.event.addListener(
          autocomplete,
          "place_changed",
          () => {
            this.updateAddressData(autocomplete.getPlace());
          }
        );

        this.isInitialized = true;
      }
    }
  }
};
</script>
